import { render, staticRenderFns } from "./PerPageSelect.vue?vue&type=template&id=56365eeb&scoped=true"
import script from "./PerPageSelect.vue?vue&type=script&lang=js"
export * from "./PerPageSelect.vue?vue&type=script&lang=js"
import style0 from "./PerPageSelect.vue?vue&type=style&index=0&id=56365eeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56365eeb",
  null
  
)

export default component.exports